import { Flex, Typography } from "antd"

export const MassPayoutsStepUi = () => {
  return (
    <Flex vertical>
      <Typography.Text>
        If you need to make bulk cryptocurrency payouts via the dashboard, you
        have two options:
      </Typography.Text>

      <ul>
        <li>
          Upload a .CSV file following the provided template (downloadable in
          this section)
        </li>

        <li>Enter payout details manually</li>
      </ul>

      <Typography.Paragraph>
        If any transactions fail during the file upload process, you can
        download a report from this section containing a list of failed
        transactions for your convenience.
      </Typography.Paragraph>

      <Typography.Text>
        Before sending, you can choose who will cover the blockchain network
        fee:
      </Typography.Text>

      <ul>
        <li>
          Sender – You cover the fee, and the recipient receives the full
          amount.
        </li>

        <li>
          Recipient – The fee is deducted from the transfer, and the recipient
          receives a reduced amount.
        </li>
      </ul>
    </Flex>
  )
}
